var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nebTooltip",class:_vm.position},[_c('span',{ref:"contentWrapper",staticStyle:{"display":"contents"},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":function($event){_vm.show = false}}},[_vm._t("default")],2),_c('div',{staticClass:"nebTooltip-tooltip",style:({
      top: _vm.top,
      left: _vm.left,
      visibility: _vm.forceOpen || _vm.show ? 'visible' : 'hidden'
    })},[_c('div',{ref:"tooltip",staticClass:"nebTooltip-tooltip-wrapper"},[_c('span',{style:(_vm.spanStyle)},[_vm._v(_vm._s(_vm.content))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }